import { css } from '@emotion/react';
import { tokens } from '@domain-group/fe-brary';

// eslint-disable-next-line
export const page = css`
  background-color: ${tokens.colors.neutral.surface.default};
`;
